import * as vp from 'vopay';

import { FunctionComponent, useContext, useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';

import BillingPackageTabs from './BillingPackageTabs';
import { BillingDetailsContext } from '../../providers/BillingDetails.provider';

const { BillingPackagePlanTypes, Badge, Box, Title } = vp;

const BillingPackageDetails: FunctionComponent<Record<never, never>> = () => {
  const packageDetails = useContext(BillingDetailsContext);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const packageName = queryParams.get('packageName') || '';
  const { resource } = useParams<{ resource: string; id: string }>();

  const [title, setTitle] = useState('');
  const [planType, setPlanType] = useState<vp.BillingPackagePlanTypes>();
  const [currency, setCurrency] = useState<'CAD' | 'USD' | undefined>();

  useEffect(() => {
    const handlers: { [resource: string]: () => void } = {
      package: () => {
        setTitle(packageName || '');
      },
      settings: () => {
        setTitle(packageName || '');
      },
      default: () => {},
    };

    const handler = handlers[resource] || handlers.default;

    handler();
  }, []);

  useEffect(() => {
    setPlanType(getPlanType(packageDetails));
    setCurrency(getCurrency(packageDetails));
  }, [packageDetails]);

  return (
    <div>
      {Object.values(packageDetails).length > 0 && (
        <Box flx="col" gapSize="36px">
          <Box flx="col">
            <Title title={title} />
            <Box pt="sm" pb="sm" gap="sm">
              <Badge label={planType || ''} color="primary" />
              <Badge label={currency || ''} color="primary" />
            </Box>
          </Box>
          <BillingPackageTabs />
        </Box>
      )}
    </div>
  );

  function getPlanType(_packageDetails: vp.PackageDetails) {
    const pType = _packageDetails?.BillingSettings?.PlanType.value;
    return pType ? BillingPackagePlanTypes[pType] : pType;
  }

  function getCurrency(_packageDetails: vp.PackageDetails) {
    return _packageDetails?.BillingSettings?.Currency?.value;
  }
};

export default BillingPackageDetails;
